import React from "react";
import classNames from "classnames"; // hoặc dùng thủ công nếu không muốn cài thư viện
import { cn } from "../../lib/utils";

const variantClasses = {
  info: {
    container: "bg-blue-50 border border-blue-200 text-blue-700",
    icon: "text-blue-500",
  },
  success: {
    container: "bg-green-50 border border-green-200 text-green-700",
    icon: "text-green-500",
  },
  warning: {
    container: "bg-yellow-50 border border-yellow-200 text-yellow-700",
    icon: "text-yellow-500",
  },
  error: {
    container: "bg-red-50 border border-red-200 text-red-700",
    icon: "text-red-500",
  },
  destructive: {
    container: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
    icon: "text-destructive",
  },
} as const;

type Variant = keyof typeof variantClasses;

interface Props {
  variant?: Variant;
  msg: string;
  className?: string;
}

export default function Alert({
  variant = "info",
  msg,
  className = "",
}: Props) {
  const styles = variantClasses[variant];

  return (
    <div
      className={classNames(
        "border rounded-lg p-2.5 flex items-start space-x-3 flex items-center",
        styles.container,
        className
      )}
    >
      <div className={classNames(styles.icon, "mt-0.5")}>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="flex-1 text-sm md:text-base lg:text-base">{msg}</div>
    </div>
  );
}

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertDescription };
